/**
 * 代码生成规则执行时机
 * @author wangjiegj<wangjiegj@inspur.com>
 */

import {I18nUtil} from "../../../i18n/i18n-service";

/**
 * 代码生成规则执行时机
 */
enum GSPBillCodeGenerateOccasion {
    /**
     * 系统定义
     */
    SystemProcess = 'SystemProcess',

    /**
     * 创建时
     */
    CreatingTime = 'CreatingTime',

    /**
     * 保存时
     */
    SavingTime = 'SavingTime',

    /**
     * 创建和保存时
     */
    BothCreatingAndSaving = 'BothCreatingAndSaving',
}

export { GSPBillCodeGenerateOccasion };


export const GSPBillCodeGenerateOccasions: Array<{ text: string, value: GSPBillCodeGenerateOccasion }> = [
    { text: I18nUtil.instant("SystemProcess"), value: GSPBillCodeGenerateOccasion.SystemProcess },
    { text: I18nUtil.instant("CreatingTime"), value: GSPBillCodeGenerateOccasion.CreatingTime },
    { text: I18nUtil.instant("SavingTime"), value: GSPBillCodeGenerateOccasion.SavingTime },
    // { text: '创建和保存时', value: GSPBillCodeGenerateOccasion.BothCreatingAndSaving }
];

